const apiUrl = process.env.REACT_APP_W_API_URL
const recaptchaSiteKey = process.env.REACT_APP_W_RECAPTCHA_SITE_KEY

export {
   apiUrl, 
   recaptchaSiteKey 
}
